import http from './http'
const baseUrl = process.env.REACT_APP_QUESTION_ANSWER_AI_URL
export const generateQuestContent = (payload) => {
    return http({
        method: 'POST',
        data: payload,
        url: `${baseUrl}/generate?service=treasure-hunt`
    })
}

export const getQuestContent = (params) => {
    return http({
        method: 'GET',
        url: `${baseUrl}/hunts?service=treasure-hunt&user_id=${params.user_id}&org_id=${params.org_id}&limit=${params.limit}&offset=${params.offset}`
    })
}

export const processLocationAction = (payload) => {
    return http({
        method: 'POST',
        data: payload,
        url: `${baseUrl}?service=treasure-hunt-location`
    })
}